(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kovaro-favorites"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kvr-favs]');
    if (!root) return;
    var grid = root.querySelector('[data-kvr-favs-grid]'),
        empty = root.querySelector('[data-kvr-favs-empty]'),
        loading = root.querySelector('[data-kvr-favs-loading]'),
        note = root.querySelector('[data-kvr-favs-note]'),
        countEl = root.querySelector('[data-kvr-favs-count]');
    var CUR = root.getAttribute('data-currency') || 'EUR';
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: CUR }); }
    catch (e) { fmt = { format: function (n) { return n.toFixed(2) + ' ' + CUR; } }; }

    function read() { try { return JSON.parse(localStorage.getItem('kvr_favs')) || []; } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem('kvr_favs', JSON.stringify(a)); } catch (e) {} }

    function card(p) {
      var a = document.createElement('a');
      a.className = 'kvr-card'; a.href = '/products/' + p.handle;

      var media = document.createElement('div'); media.className = 'kvr-card__media';
      if (p.featured_image) {
        var img = document.createElement('img');
        img.className = 'kvr-card__img'; img.loading = 'lazy';
        img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
        img.alt = p.title;
        media.appendChild(img);
      }
      if (!p.available) {
        var s = document.createElement('span'); s.className = 'kvr-favs__sold'; s.textContent = 'Sold';
        media.appendChild(s);
      }
      a.appendChild(media);

      var row = document.createElement('div'); row.className = 'kvr-card__row';
      var h3 = document.createElement('h3'); h3.className = 'kvr-card__title'; h3.textContent = p.title;
      var pr = document.createElement('span'); pr.className = 'kvr-card__price'; pr.textContent = fmt.format((p.price || 0) / 100);
      row.appendChild(h3); row.appendChild(pr);
      a.appendChild(row);
      return a;
    }

    function render() {
      var handles = read();
      if (!handles.length) { finish([], []); return; }
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (res) {
        var ok = [], keep = [];
        res.forEach(function (p, i) { if (p) { ok.push(p); keep.push(handles[i]); } });
        if (keep.length !== handles.length) write(keep);   /* geloeschte Produkte aufraeumen */
        finish(ok, keep);
      });
    }

    function finish(products) {
      if (loading) loading.hidden = true;
      grid.textContent = '';
      if (!products.length) {
        empty.hidden = false; grid.hidden = true; if (note) note.hidden = true;
        if (countEl) countEl.textContent = '0 saved';
      } else {
        empty.hidden = true; grid.hidden = false; if (note) note.hidden = false;
        products.forEach(function (p) { grid.appendChild(card(p)); });
        if (countEl) countEl.textContent = products.length + (products.length === 1 ? ' piece saved' : ' pieces saved');
      }
      if (window.kvrFav) { window.kvrFav.inject(grid); window.kvrFav.sync(); }
    }

    document.addEventListener('kvr:favchange', function () { render(); });
    if (document.readyState !== 'loading') render(); else document.addEventListener('DOMContentLoaded', render);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kovaro-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kvr-rev-carousel').forEach(function (car) {
    var track = car.querySelector('.kvr-rev-track');
    if (!track) return;
    function step(){ var c = track.querySelector('.kvr-rev-card'); return c ? c.offsetWidth + 22 : 540; }
    var p = car.querySelector('.kvr-rev-arrow--prev'), n = car.querySelector('.kvr-rev-arrow--next');
    if (p) p.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior:'smooth' }); });
    if (n) n.addEventListener('click', function(){ track.scrollBy({ left:  step(), behavior:'smooth' }); });
    /* mouse-wheel -> horizontal; releases to page scroll at the ends */
    track.addEventListener('wheel', function(e){
      var d = e.deltaY;
      if (Math.abs(d) <= Math.abs(e.deltaX)) return;
      var max = track.scrollWidth - track.clientWidth;
      if ((d < 0 && track.scrollLeft <= 0) || (d > 0 && track.scrollLeft >= max - 1)) return;
      track.scrollLeft += d; e.preventDefault();
    }, { passive:false });
    /* drag-to-scroll (desktop) */
    var down=false, sx=0, sl=0;
    track.addEventListener('pointerdown', function(e){ if(e.pointerType==='mouse'){ down=true; sx=e.clientX; sl=track.scrollLeft; track.style.cursor='grabbing'; } });
    window.addEventListener('pointerup', function(){ down=false; track.style.cursor=''; });
    track.addEventListener('pointermove', function(e){ if(down){ track.scrollLeft = sl-(e.clientX-sx); } });
  });

  } catch(e) { console.error(e); }
})();
})();
